import { render, staticRenderFns } from "./AddSurgeryDocumentPopup.vue?vue&type=template&id=510b7338"
import script from "./AddSurgeryDocumentPopup.vue?vue&type=script&lang=js"
export * from "./AddSurgeryDocumentPopup.vue?vue&type=script&lang=js"
import style0 from "./AddSurgeryDocumentPopup.vue?vue&type=style&index=0&id=510b7338&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports